import { themeAtom } from "../../shared/atoms";
import Rating from "../../shared/components/Rating";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

export function RightshipRating(internalPerfData: any[] | null) {
  const theme = useAtomValue(themeAtom);

  return (
    <div
      className={twMerge(
        "mb-4 rounded-lg p-4 shadow-md",
        theme.home.tailwind.panelBackground,
        theme.home.tailwind.textDefault,
      )}
    >
      <h1 className="mb-4 text-2xl font-bold">Rightship Rating</h1>
      <div className={twMerge("grid grid-cols-5 gap-4", theme.vesselDetails.fields)}>
        <div className="py-2">
          <div className="pb-2 text-xs font-normal">Safety score</div>
          <div className="text-sm font-normal">
            <b>{internalPerfData?.[0]?.RIGHTSHIP_SAFETY_SCORE || ""}</b>/5
          </div>
        </div>
        <div className="py-2">
          <div className="pb-2 text-xs font-normal">Assessment of</div>
          <div className="text-sm font-normal">
            {new Date(internalPerfData?.[0]?.RIGHTSHIP_GHG_RATING_TIMESTAMP || "").toLocaleDateString("en-GB", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })}
          </div>
        </div>
        <div className="py-2">
          <div className="pb-2 text-xs font-normal">GHG Rating</div>
          <div className="relative">
            <Rating label={internalPerfData?.[0]?.RIGHTSHIP_GHG_RATING} />
          </div>
        </div>
        <div className="py-2">
          <div className="pb-2 text-xs font-normal">Assessment as of</div>
          <div className="text-sm font-normal">
            {new Date(internalPerfData?.[0]?.RIGHTSHIP_SAFETY_SCORE_TIMESTAMP || "").toLocaleDateString("en-GB", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
